import React from 'react';

const LoadingSpinner = ({ message = 'Loading...', className = '' }) => {
  return (
    <div className={`flex items-center justify-center min-h-screen bg-background ${className}`}>
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-accent mb-4"></div>
        <p className="text-white text-lg">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
